export default __webpack_public_path__ + "static/media/mb.1093af2f.jpeg";